import React, { useState } from 'react';
import {
  TextField,
  Button,
  IconButton,
  InputAdornment,
} from '@material-ui/core';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import { useNavigate, useLocation } from 'react-router-dom';
import { useQueryClient } from 'react-query';
import { loginAdminUserRaw, setToken, handleError } from '../../common/ApiUtility';
import { getDefaultAdminPath } from '../Layouts/adminSidebarRoutes';
import { LOGGED_IN_USER_QUERY_KEY } from '../Layouts/Hooks';
import { setAdminPortalType } from '../../utils/adminPortal';
import './Login.css';
import BrandWorldLogo from "../../assets/BrandWorldLogo.svg";


const BXILOGO = 'https://bxidevelopment1.s3.ap-south-1.amazonaws.com/assets/BXI_LOGO.png';

const Login = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { pathname } = useLocation();
  const isBXI = pathname.includes('/login/bxi');

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');

  const logo = isBXI ? BXILOGO : BrandWorldLogo;
  const alt = isBXI ? 'BXI' : 'Brand World';
  const subtitle = isBXI
    ? 'Company & membership management'
    : 'Orders, wallet, inventory & transactions';

  const handleUsernameChange = (e) => {
    setUsername(e.target.value);
    setError('');
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!username || !password) {
      setError('Please enter both email and password.');
      return;
    }
    try {
      const portalAdminType = isBXI ? "bxi" : "brand_world";
      const res = await loginAdminUserRaw(username, password, portalAdminType);
      const data = res?.data || {};
      const token = data.token;
      const adminType = data.adminType || portalAdminType;

      if (!token) {
        setError('Invalid response. Please try again.');
        return;
      }
      if (isBXI && adminType !== 'bxi') {
        setError('This account is for Brand World. Use Brand World Admin Login.');
        return;
      }
      if (!isBXI && adminType === 'bxi') {
        setError('This account is for BXI Admin. Use BXI Admin Login.');
        return;
      }
      setAdminPortalType(portalAdminType);
      queryClient.removeQueries(LOGGED_IN_USER_QUERY_KEY);
      localStorage.setItem('admintoken', token);
      setToken(token);
      navigate(getDefaultAdminPath(portalAdminType, data.acess || []));
    } catch (err) {
      handleError('Invalid email or password.');
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo" style={{ textAlign: "center", marginBottom: "1rem" }}>
          <img
            src={logo}
            alt={alt}
            style={{
              width: "100%",
              maxWidth: isBXI ? "180px" : "200px",
              maxHeight: "100px",
              objectFit: "contain"
            }}
          />
        </div>
        <p className="login-subtitle">{subtitle}</p>

        <form className="login-form" onSubmit={handleSubmit}>
          <TextField
            label="Email"
            type="email"
            value={username}
            onChange={handleUsernameChange}
            fullWidth
            variant="outlined"
            size="small"
            autoComplete="email"
          />
          <TextField
            label="Password"
            type={showPassword ? 'text' : 'password'}
            value={password}
            onChange={handlePasswordChange}
            fullWidth
            variant="outlined"
            size="small"
            error={!!error}
            helperText={error}
            autoComplete="current-password"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password"
                    onClick={() => setShowPassword(!showPassword)}
                    edge="end"
                    size="small"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            className="login-submit"
          >
            Sign in
          </Button>
          <button
            type="button"
            className="login-back-link"
            onClick={() => navigate('/login')}
          >
            ← Choose another admin login
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;


